import { GraphQLWsLink } from '@apollo/client/link/subscriptions'

import { createClient } from 'graphql-ws'
import { getMainDefinition } from '@apollo/client/utilities'
import { ApolloLink, split } from '@apollo/client'
import { rallyEnv } from '@plvs/rally/env'
import { noop } from 'ramda-adjunct'
import { uploadLink } from './uploadLink'

const HTTPS_HEADER_LENGTH = 'https://'.length
const WS_HEADER = 'wss://'

export const splitLink = (
  jwt?: string,
  requestUrl?: string,
  addLog: (log: unknown) => void = noop
): ApolloLink => {
  const authorization = jwt ? `Bearer ${jwt}` : ''
  const wsClient = createClient({
    url:
      requestUrl && !requestUrl.startsWith('https://app-local.staging.plvs.io') // local proxy not supported for ws
        ? `${WS_HEADER}${requestUrl.substring(HTTPS_HEADER_LENGTH)}/graphql`
        : rallyEnv.GRAPHQL_WS_URL,

    connectionParams: { authorization },
  })

  wsClient.on('error', (error) => {
    addLog(`[wsClient | error] ${JSON.stringify(error, null, 2)}`)
  })

  return typeof window !== 'undefined'
    ? split(
        ({ query }) => {
          const definition = getMainDefinition(query)
          return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
          )
        },
        new GraphQLWsLink(wsClient),
        uploadLink(jwt, requestUrl)
      )
    : uploadLink(jwt, requestUrl)
}
